import { createTypes, createAction } from "lib/action";

const LOAD_SYNC_BLOCKS = createTypes("syncBlocks", "list");
const TOGGLE_SYNC_BLOCK = createTypes("syncBlocks", "toggle");

const loadSyncBlocks = {
  request: () => createAction(LOAD_SYNC_BLOCKS.REQUEST),
  success: data => createAction(LOAD_SYNC_BLOCKS.SUCCESS, { data }),
  failure: error => createAction(LOAD_SYNC_BLOCKS.FAILURE, { error })
};

const toggleSyncBlock = {
  request: branchId => createAction(TOGGLE_SYNC_BLOCK.REQUEST, { branchId }),
  success: data => createAction(TOGGLE_SYNC_BLOCK.SUCCESS, { data }),
  failure: error => createAction(TOGGLE_SYNC_BLOCK.FAILURE, { error })
};

export {
  LOAD_SYNC_BLOCKS,
  loadSyncBlocks,
  TOGGLE_SYNC_BLOCK,
  toggleSyncBlock
};
